import axiosInstance from './axiosConfig';

const formAPI = {
    // Form 2306 APIs (updated)
    getForm2306ByClient: async (clientId, params = {}) => {
        try {
            const response = await axiosInstance.get(`/form-2306/client/${clientId}`, { params });
            return response.data;
        } catch (error) {
            console.error('Form 2306 API Error:', error.response?.data || error.message);
            throw error.response?.data?.message || 'Failed to fetch Form 2306 records';
        }
    },

    // Period (month/quarter/fiscalYear) is derived server-side from each
    // record's own transactionDate — there's no batch-level period to send.
    createForm2306Records: async (clientId, records) => {
        try {
            const response = await axiosInstance.post(`/form-2306/client/${clientId}`, { records });
            return response.data;
        } catch (error) {
            console.error('Form 2306 Creation Error:', error.response?.data || error.message);
            throw error.response?.data?.message || 'Failed to create Form 2306 records';
        }
    },

    // Form 2307 APIs (updated)
    getForm2307ByClient: async (clientId, params = {}) => {
        try {
            const response = await axiosInstance.get(`/form-2307/client/${clientId}`, { params });
            return response.data;
        } catch (error) {
            console.error('Form 2307 API Error:', error.response?.data || error.message);
            throw error.response?.data?.message || 'Failed to fetch Form 2307 records';
        }
    },

    // Period (month/fiscalYear) is derived server-side from each record's own
    // transactionDate — there's no batch-level period to send.
    // `correctionReason` is required by the backend. Certificates are generated
    // automatically when a VAT transaction with an ATC is posted; this endpoint
    // is the correction / reissue path only.
    createForm2307Records: async (clientId, records, correctionReason) => {
        try {
            const response = await axiosInstance.post(`/form-2307/client/${clientId}`, { records, correctionReason });
            return response.data;
        } catch (error) {
            console.error('Form 2307 Creation Error:', error.response?.data || error.message);
            throw error.response?.data?.message || 'Failed to create Form 2307 records';
        }
    },

    // Helper functions
    calculateTaxWithheld: (baseAmount, withholdingRate) => {
        const base = parseFloat(baseAmount) || 0;
        const rate = parseFloat(withholdingRate) || 0;
        return parseFloat(((base * rate) / 100).toFixed(2));
    },

    getMonthName: (monthNumber) => {
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        return months[monthNumber - 1] || '';
    },

    getMonths: () => {
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        return Array.from({ length: 12 }, (_, i) => ({
            value: i + 1,
            label: months[i]
        }));
    },

    getFiscalYears: () => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let year = currentYear + 5; year >= currentYear - 5; year--) {
            years.push({ value: year, label: year.toString() });
        }
        return years;
    },

    // ATC codes moved to the BIR reference table — see api/atcCodeAPI.js and
    // hooks/useAtcCodes.js. The list that lived here embedded the rate in a
    // display string, carried no issuance or effective date, and had drifted
    // out of step with two other copies of the same data.

    updateForm2306Record: async (recordId, updateData) => {
    try {
        const response = await axiosInstance.put(`/form-2306/${recordId}`, updateData);
        return response.data;
    } catch (error) {
        console.error('Form 2306 Update Error:', error.response?.data || error.message);
        throw error.response?.data?.message || 'Failed to update Form 2306 record';
    }
    },

    deleteForm2306Record: async (recordId) => {
    try {
        const response = await axiosInstance.delete(`/form-2306/${recordId}`);
        return response.data;
    } catch (error) {
        console.error('Form 2306 Delete Error:', error.response?.data || error.message);
        throw error.response?.data?.message || 'Failed to delete Form 2306 record';
    }
    },

    updateForm2307Record: async (recordId, updateData) => {
    try {
        const response = await axiosInstance.put(`/form-2307/${recordId}`, updateData);
        return response.data;
    } catch (error) {
        console.error('Form 2307 Update Error:', error.response?.data || error.message);
        throw error.response?.data?.message || 'Failed to update Form 2307 record';
    }
    },

    deleteForm2307Record: async (recordId) => {
    try {
        const response = await axiosInstance.delete(`/form-2307/${recordId}`);
        return response.data;
    } catch (error) {
        console.error('Form 2307 Delete Error:', error.response?.data || error.message);
        throw error.response?.data?.message || 'Failed to delete Form 2307 record';
    }
    },
};

export default formAPI;